$.TemplateMarketingDirectory = {
    DisplayedPNs: [],
    StoredFilters: {},
    SearchTimeout: null,

    EvaluateFilters: () => {
        let filters = {
            "part-numbers": [],
            "file-types": [],
            "product-categories": [],
            "file-categories": [],
        };

        $(".tpl-marketing-directory #file-filters input:checked").each(
            function (index, input) {
                const propertyId = $(input).data("property");
                const propertyValueId = $(input).data("value");

                if (!filters[propertyId]) filters[propertyId] = [];

                filters[propertyId].push(propertyValueId);
            },
        );

        if (
            JSON.stringify(filters) !==
            JSON.stringify($.TemplateMarketingDirectory.StoredFilters)
        ) {
            $.TemplateMarketingDirectory.StoredFilters = filters;
            if (!!$.TemplateMarketingDirectory.SearchTimeout)
                clearTimeout($.TemplateMarketingDirectory.SearchTimeout);
            $.TemplateMarketingDirectory.SearchTimeout = setTimeout(() => {
                $.TemplateMarketingDirectory.Search();
            }, 1000);
        }
    },

    ClearFilters: () => {
        $.TemplateMarketingDirectory.DisplayedPNs = [];
        const ul = $("#property-part-numbers ul");
        ul.empty();

        $(".tpl-marketing-directory #file-filters input:checked").each(
            function (index, input) {
                $(input).prop("checked", false);
            },
        );

        $.TemplateMarketingDirectory.EvaluateFilters();
    },

    SearchProduct: (language) => {
        let list = $("#product-search-modal .list-group");
        list.empty();
        $("#product-search-modal #noRecordsFound")
            .removeClass("d-block")
            .addClass("d-none");

        let search = $("#product-search-modal input").val();
        let res = $.Backend.SearchProduct(search, language, false, true);
        res.then(function (response) {
            const data = response.data;
            if (data.products.length > 0) {
                for (let product of data.products)
                    list.append(
                        `<a href="#" onClick="javascript:$.TemplateMarketingDirectory.AddPNFilter('${product.partNumber}')" class="list-group-item list-group-item-action" data-bs-dismiss="modal">${product.name} (${product.partNumber})</a>`,
                    );
            } else {
                $("#product-search-modal #noRecordsFound")
                    .removeClass("d-none")
                    .addClass("d-block");
            }
        });
    },

    AddPNFilter: (pn) => {
        const pns = [...$.TemplateMarketingDirectory.DisplayedPNs, pn].filter(
            (value, index, array) => array.indexOf(value) === index,
        );

        $.TemplateMarketingDirectory.DisplayedPNs = pns;

        const ul = $("#property-part-numbers ul");
        ul.empty();
        for (let pn of pns) {
            const el = $(`
                <li>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox"
                            value="${pn}" data-property="part-numbers"
                            data-value="${pn}" checked>
                        <label class="form-check-label">
                            ${pn}
                        </label>
                    </div>
                </li>
            `);
            ul.append(el);

            $(el)
                .find(".form-check")
                .on("click", function (e) {
                    $(el).remove();
                    $.TemplateMarketingDirectory.RemovePNFilter(pn);
                });
        }

        $.TemplateMarketingDirectory.EvaluateFilters();
    },

    RemovePNFilter: (pn) => {
        const pns = $.TemplateMarketingDirectory.DisplayedPNs.filter(
            (item) => item !== pn,
        );
        $.TemplateMarketingDirectory.DisplayedPNs = pns;
        $.TemplateMarketingDirectory.EvaluateFilters();
    },

    Search: (page = 1, paginate = false) => {
        const lang = $(".tpl-marketing-directory").data("lang");
        const notFound = $("#files-container").data("not-found");
        const defaultBestContentLabel = $("#files-container").data(
            "default-best-content-label",
        );

        const resultsEl = $("#files-container");
        resultsEl.empty();
        resultsEl.append(`
            <div class="col p-5 d-flex justify-content-center">
                <div class="spinner-border text-vb-blue" role="status" style="width: 5rem; height: 5rem;">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        `);

        $.Backend.MarketingDirectorySearch(
            $.TemplateMarketingDirectory.StoredFilters,
            page,
            defaultBestContentLabel,
            lang,
        ).then((response) => {
            const data = response.data;
            console.log(data);
            resultsEl.empty();

            if (data.count === 0) {
                resultsEl.append(`
                    ${
                        data.productLinks.trim() !== ""
                            ? `<div class="col-12 mb-3">
                                ${data.productLinks}
                            </div>`
                            : ""
                    }
                    <div class="col p-5 d-flex justify-content-center">
                        <div class="badge not-found">${notFound}</div>                        
                    </div>
                `);
            } else {
                let pagination = "";
                if (data.pages > 1) {
                    let pageStart = Math.max(data.page - 2, 1);
                    const pageEnd = Math.min(pageStart + 4, data.pages);
                    if (pageEnd - pageStart < 4)
                        pageStart = Math.max(pageEnd - 4, 1);

                    for (let p = pageStart; p < pageEnd + 1; p++) {
                        pagination += `
                    <li class="page-item${data.page === p ? " active" : ""}">
                        <button class="page-link" onClick="javascript:$.TemplateMarketingDirectory.Search(${p}, true);">${p}</button>
                    </li>
                `;
                    }

                    if (page > 1)
                        pagination =
                            `<li class="page-item">
                        <button class="page-link" onClick="javascript:$.TemplateMarketingDirectory.Search(${
                            page - 1
                        }, true);">&laquo;</button>
                    </li>` + pagination;
                    if (page < data.pages)
                        pagination = `${pagination}<li class="page-item">
                        <button class="page-link" onClick="javascript:$.TemplateMarketingDirectory.Search(${
                            page + 1
                        }, true);">&raquo;</button>
                    </li>`;
                }

                resultsEl.html(`
                    ${
                        data.productLinks.trim() !== ""
                            ? `<div class="col-12 mb-3">
                                ${data.productLinks}
                            </div>`
                            : ""
                    }
                    ${
                        data.pages > 1
                            ? `<div class="col-12 d-flex align-items-center justify-content-between mb-3">            
                        <ul class="pagination mb-0">${pagination}</ul>          
                        <small>${data.page} / ${data.pages}</small>
                        </div>`
                            : ""
                    }
                    ${data.files}
                    ${
                        data.pages > 1
                            ? `<div class="col-12 d-flex align-items-center justify-content-between mb-3">            
                        <ul class="pagination mb-0">${pagination}</ul>          
                        <small>${data.page} / ${data.pages}</small>
                        </div>`
                            : ""
                    }
                `);

                $.TemplateMarketingDirectory.HighlightFiles();
                if (paginate) {
                    const filesEl = $("#files");
                    if (filesEl.length)
                        $("html, body").animate(
                            { scrollTop: filesEl.offset().top - 90 },
                            400,
                        );
                }
            }
        });
    },

    SetThumbnailPreview: (url) => {
        $("#previewThumbnailModal img").attr("src", url);
    },

    GetCart: () => {
        const cart = sessionStorage.getItem("downloads");
        return cart ? JSON.parse(cart) : [];
    },

    ToggleDownload: (uuid, name, variants, thumbnail, files) => {
        let cart = $.TemplateMarketingDirectory.GetCart();
        if (cart.find((item) => item.uuid === uuid)) {
            cart = cart.filter((item) => item.uuid !== uuid);
        } else cart.push({ uuid, name, variants, thumbnail, files });
        sessionStorage.setItem("downloads", JSON.stringify(cart));
        $.TemplateMarketingDirectory.RefreshCart();
    },

    ClearCart: () => {
        sessionStorage.setItem("downloads", JSON.stringify([]));
        $.TemplateMarketingDirectory.RefreshCart();
    },

    RefreshCart: () => {
        let cart = $.TemplateMarketingDirectory.GetCart();

        $("#cart ul").empty();
        let fileCount = 0;
        for (let item of cart) {
            $("#cart ul").append(
                `<li class="list-group-item d-flex align-items-center justify-content-between">
                    <div class="d-flex">
                      ${
                          item.thumbnail
                              ? `<img src="${item.thumbnail}" class="cart-thumbnail me-1">`
                              : '<div class="cart-no-thumbnail me-1"><i class="fa fa-file"></i></div>'
                      }
                      <div>
                        <span class="fw-bold">${item.name}</span>
                        <small>(${item.variants})</small>
                      </div>
                    </div>
                    <button class="btn btn-vb-white btn-small" onClick="$.TemplateMarketingDirectory.ToggleDownload('${
                        item.uuid
                    }')">
                      <i class="fa fa-trash"></i>
                    </button>
                </li>`,
            );
            fileCount += item.files;
        }

        if (fileCount === 0) {
            $("#cart").hide();
        } else {
            $("#cart").show();
        }

        $("#cart-count").html(fileCount);
        $.TemplateMarketingDirectory.HighlightFiles();
    },

    DownloadCart: (path) => {
        const cart = $.TemplateMarketingDirectory.GetCart();
        const uuids = cart.map((item) => item.uuid);
        $.TemplateMarketingDirectory.ClearCart();
        $("#downloadCartOverlay").addClass("show");
        $.Backend.MarketingDirectoryDownloadBundle(path, uuids).then(() =>
            $("#downloadCartOverlay").removeClass("show"),
        );
    },

    HighlightFiles: () => {
        const cart = $.TemplateMarketingDirectory.GetCart();
        $(`.md-file`).removeClass("highlight");
        for (let item of cart) {
            $(`.md-file[data-uuid='${item.uuid}']`).addClass("highlight");
        }
    },
};

$(document).ready(function () {
    $(".tpl-marketing-directory #file-filters .form-check").on(
        "click",
        function (e) {
            e.stopPropagation();
            const input = $(this).find("input");
            input.prop("checked", !input.prop("checked"));
            $.TemplateMarketingDirectory.EvaluateFilters();
        },
    );

    $(".tpl-marketing-directory #cart .cart-toggle").on("click", function () {
        $("#cart").toggleClass("show");
    });

    if ($(".tpl-marketing-directory").length) {
        $.TemplateMarketingDirectory.EvaluateFilters();
        $.TemplateMarketingDirectory.RefreshCart();
    }
});
